// src/App.js
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider, useAuth } from './context/AuthContext'
import AppLayout from './components/layout/AppLayout'
import Login from './pages/auth/Login'
import Dashboard from './pages/dashboard/Dashboard'
import Animales from './pages/agro/Animales'
import Vacunas from './pages/agro/Vacunas'
import Cultivos from './pages/cultivos/Cultivos'
import Finanzas from './pages/finanzas/Finanzas'
import Usuarios from './pages/admin/Usuarios'
import Reportes from './pages/reportes/Reportes'
import Reproduccion from './pages/agro/Reproduccion'
import Clientes from './pages/clientes/Clientes'
import './styles/globals.css'

function PrivateRoute({ children, roles }) {
  const { user, profile, loading } = useAuth()

  if (loading) return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
      <div className="spinner spinner-dark" />
    </div>
  )
  if (!user) return <Navigate to="/login" replace />
  if (roles && profile && !roles.includes(profile.rol)) {
    return (
      <AppLayout>
        <div style={{ textAlign: 'center', padding: 80 }}>
          <div style={{ fontSize: 48, marginBottom: 16 }}>🔒</div>
          <h2>Acceso restringido</h2>
          <p style={{ color: 'var(--dark-500)', marginTop: 8 }}>No tenés permisos para acceder a esta sección.</p>
        </div>
      </AppLayout>
    )
  }

  return <AppLayout>{children}</AppLayout>
}

function PublicRoute({ children }) {
  const { user, loading } = useAuth()
  if (loading) return null
  if (user) return <Navigate to="/dashboard" replace />
  return children
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
          <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
          <Route path="/animales" element={<PrivateRoute roles={['admin','capataz','veterinario']}><Animales /></PrivateRoute>} />
          <Route path="/vacunas" element={<PrivateRoute roles={['admin','veterinario']}><Vacunas /></PrivateRoute>} />
          <Route path="/reproduccion" element={<PrivateRoute roles={['admin','capataz','veterinario']}><Reproduccion /></PrivateRoute>} />
          <Route path="/cultivos" element={<PrivateRoute roles={['admin','capataz']}><Cultivos /></PrivateRoute>} />
          <Route path="/finanzas" element={<PrivateRoute roles={['admin','finanzas']}><Finanzas /></PrivateRoute>} />
          <Route path="/clientes" element={<PrivateRoute roles={['admin','comercial']}><Clientes /></PrivateRoute>} />
          <Route path="/reportes" element={<PrivateRoute roles={['admin','finanzas','inversionista']}><Reportes /></PrivateRoute>} />
          <Route path="/usuarios" element={<PrivateRoute roles={['admin']}><Usuarios /></PrivateRoute>} />
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  )
}
